<template>
  <div id="navbar">
    <b-navbar class="navbar">
      <template slot="start">
        <b-navbar-item tag="router-link" :to="{ path: '/' }" id="navbar-logo">
          <img id="logo" alt="איילת נוף עורכת דין נוטריון" src="../../images/logo4.png" />
        </b-navbar-item>
        <b-navbar-item class="border" />
      </template>

      <template slot="end">
        <b-navbar-item tag="router-link" :to="{ path: '/' }">אודות</b-navbar-item>
        <b-navbar-item class="spacer" />
        <b-navbar-item tag="router-link" :to="{ path: '/תחומי-עיסוק' }">תחומי עיסוק</b-navbar-item>
        <b-navbar-item class="spacer" />
        <b-navbar-item tag="router-link" :to="{ path: '/הישגים-משפטיים' }">הישגים משפטיים</b-navbar-item>
        <b-navbar-item class="spacer" />
        <b-navbar-dropdown
          label="טור אישי"
          :right="true"
          :arrowless="true"
          :boxed="true"
          :collapsible="true"
        >
          <b-navbar-item v-on:click="click('first')" class="dropdown-item">עבודה משתלמת ללא הספק</b-navbar-item>
          <b-navbar-item v-on:click="click('second')" class="dropdown-item">כל העולם במה</b-navbar-item>
          <b-navbar-item v-on:click="click('third')" class="dropdown-item">פניה הרבות של האמת</b-navbar-item>
        </b-navbar-dropdown>
        <b-navbar-item class="spacer" />
        <b-navbar-item tag="router-link" :to="{ path: '/צור-קשר' }">צור קשר</b-navbar-item>
      </template>

      <template slot="end">
        <b-navbar-item class="border" />
        <b-navbar-item>
          <a href="tel:+97246275556" id="phone-number">04-6275556</a>
          <b-icon pack="fas" icon="phone" size="is-small" type="is-info" id="phone-number-icon" />
        </b-navbar-item>
      </template>
    </b-navbar>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "navbar",
  methods: {
    click(storyPosition) {
      this.$store.commit("updateCurrLawStory", storyPosition);

      const path = "/טור-אישי";
      if (this.$route.path !== path) {
        this.$router.push(path);
      }
    }
  },
  computed: {
    ...mapState(["currLawStory"])
  }
};
</script>

<style scoped>
#navbar {
  padding-bottom: 2.7vh;
  direction: rtl;
  font-size: 155%;
  font-family: "Gill Sans", "Gill Sans MT", Calibri, "Trebuchet MS", sans-serif;
  font-weight: 500;
}
#navbar-logo {
  width: 24.5vh;
  height: 24.5vh;
  display: flex;
  justify-content: center;
}
#logo {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.border {
  width: 7.3vw;
  pointer-events: none;
}
.spacer {
  pointer-events: none;
}
>>> .navbar-dropdown {
  margin-top: -3.5vw;
}
.dropdown-item {
  text-align: right;
}
#phone-number {
  color: #1a1300;
}
#phone-number-icon {
  pointer-events: none;
  padding-right: 3.5vh;
}
</style>
